import React, { useState, useEffect } from 'react';
import Slider from '@material-ui/core/Slider';
import { withStyles } from '@material-ui/core/styles';
import HelpBalloon from '../../Intelligence/component/HelpBalloon/HelpBalloon';

const MenuTypes = {
  NumberOp: 'NumberOp',
  SuggestionOp: 'SuggestionOp',
};

const PrettoSlider = withStyles({
  root: {
    color: '#515F75',
    height: 8,
  },
  thumb: {
    height: 20,
    width: 20,
    backgroundColor: '#fff',
    border: '2px solid #0d84ff',
    marginTop: -6,
    marginLeft: -10,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);

export default (props) => {
  const { item, doUpdateItem } = props;

  const initialConditionValues = {
    confidence: item?.confidence !== null ? item?.confidence : 50,
  };

  const [conditionValues, setConditionValues] = useState(
    initialConditionValues
  );
  const [options, setOptions] = useState(
    item.menuOptions || { NumberOp: true, SuggestionOp: false }
  );

  const handleChangeConfidence = (value) => {
    const temp = { ...conditionValues };
    temp.confidence = value;
    
    doUpdateItem({ confidence: value });
    setConditionValues(temp);
  };

  useEffect(() => {
    if (item && item.menuOptions) {
      setOptions(item.menuOptions);
    }
    const temp = { ...conditionValues };
    temp.confidence = item?.confidence !== null ? item?.confidence : 50;
    setConditionValues(temp)
  }, [item]);

  return (
    <div className="menu-right-settings-container">
      
      <div className="mt-1">
        <span>
          Taxa de Confiança: {`${conditionValues?.confidence}%`}
          <HelpBalloon
            id="confidenceRate"
            message="Grau de certeza que a IA vai categorizar um texto."
          />
        </span>
        <PrettoSlider
          aria-label="pretto slider"
          step={1}
          min={0}
          max={100}
          name="confidence"
          onChange={(e, value) => handleChangeConfidence(value)}
          value={conditionValues?.confidence || 0}
        />
      </div>
      <div className="menu-error-message-container">
        <strong>Mensagem de erro</strong>
      </div>
    </div>
  );
};
